import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.de'

export default createLendingBundle(whitepaper)
